import { CsvButton } from '@components/Buttons/CsvButton';
import { ModalWindow } from '@components/Modal/ModalWindow';
import { ModalWindowContent } from '@components/Modal/ModalWindowContent';
import { ModalWindowTitle } from '@components/Modal/ModalWindowTitle';
import { TableWrapper } from '@components/Table/TableWrapper';
import { useData } from '@hooks/useData';
import { useField } from '@hooks/useField';
import useLoading from '@hooks/useLoading';
import useMessage from '@hooks/useMessage';
import { IModalWindow } from '@hooks/useModalWindow';
import { Box } from '@material-ui/core';
import { IRetornoItem } from '@model/RetornoItem';
import { EnumRetornoItemStatus } from '@model/RetornoItemStatus';
import { IRetornoItemFilter, useRetornoService } from '@services/RetornoService';
import React from 'react';
import { RetornoDetalheTable } from './RetornoDetalheTable';

export type RetornoDetalheModalProps = {
    retornoId: number
    modal: IModalWindow
}

export function RetornoDetalheModal ({ retornoId, modal }: RetornoDetalheModalProps) {
    const loading = useLoading();
    const message = useMessage();

    const retornoService = useRetornoService();

    const data = useData<IRetornoItem, IRetornoItemFilter>({
        filter: {
            retornoItemStatus: useField(EnumRetornoItemStatus.None)
        }
    })

    const handleEnter = React.useCallback(() => {
        data.filter.reset();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleCsvButtonClick = React.useCallback(() => {
        if (!loading.isLoading) {
            const filterValues = data.filter.getInputValues();

            loading.start();
            retornoService.exportarItens(retornoId, filterValues)
                .catch(message.showBlobException)
                .finally(loading.stop);
        }
    }, [data.filter, loading, message.showBlobException, retornoId, retornoService]);

    React.useEffect(() => {
        if (!loading.isLoading) {
            const filterValues = data.filter.getInputValues();

            loading.start();
            retornoService.listarItens(retornoId, filterValues)
                .then(data.handleDataResponse)
                .catch(message.showException)
                .finally(loading.stop);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data.requestedData, retornoId])

    return (
        <ModalWindow
            modal={modal}
            disabled={loading.isLoading}
            size="md"
            TransitionProps={{
                onEnter: handleEnter
            }}
        >
            <ModalWindowTitle
                title={`Itens do Retorno ${retornoId}`}
            />

            <ModalWindowContent>
                <Box>
                    <CsvButton onClick={handleCsvButtonClick} disabled={loading.isLoading} />
                </Box>

                <TableWrapper>
                    <RetornoDetalheTable 
                        data={data}
                    />
                </TableWrapper>
            </ModalWindowContent>
        </ModalWindow>
    )
}